import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_84: FaireProductEntity = {
  token: "legacy_prod_abbott-84",
  type: "product",
  name: "Large We Care Dancing Bees Napkins, 20 Pack",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/6b25a07f674e7ced579d8c05ff24e75354a6baf09d2cb2414cef20369d687465.jpeg",
  priceDollars: 12,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
